




import { Vue, Component, Prop } from 'vue-property-decorator';
import { IField } from '@/dealroom/fields/types/field';

@Component
export default class MergeField extends Vue {
  @Prop() field!: IField;

  get value(): string {
    return this.field.value || this.field.label || '';
  }
}
